<template>
  <div class="page-section">
    <div class="header">
      <div class="info">
        <div class="title" v-if="title">
          {{ title }}
        </div>

        <div class="description" v-if="description">
          {{ description }}
        </div>
      </div>

      <div class="controls">
        <slot name="controls" />
      </div>
    </div>

    <div class="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageSection',

  props: {
    title: {
      type: String,
      required: false
    },

    description: {
      type: String,
      required: false
    }
  }
}
</script>

<style scoped>
.page-section {
  margin-bottom: 20px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.title {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #4b515f;
}

.description {
  color: #7e8596;
  margin-top: 14px;
  font-size: 12px;
}

.controls {
  white-space: nowrap;
  padding-left: 20px;
}

.controls > * {
  margin-right: 20px;
}

.controls > *:last-child {
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/common/components/page/PageSection.vue